import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from '@/components/layout/AppLayout';
import { ProtectedRoute } from './ProtectedRoute';
import { LoginPage } from '@/features/auth/LoginPage';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { MapPage } from '@/features/map/MapPage';
import { DevicesPage } from '@/features/devices/DevicesPage';
import { DeviceDetailPage } from '@/features/devices/DeviceDetailPage';
import { ReportsPage } from '@/features/reports/ReportsPage';
import { EventsReportPage } from '@/features/reports/EventsReportPage';
import { SummaryReportPage } from '@/features/reports/SummaryReportPage';
import { TripsReportPage } from '@/features/reports/TripsReportPage';
import { StopsReportPage } from '@/features/reports/StopsReportPage';
import { RouteReportPage } from '@/features/reports/RouteReportPage';
import { HoursReportPage } from '@/features/reports/HoursReportPage';
import { GeofencesPage } from '@/features/geofences/GeofencesPage';
import { MaintenancePage } from '@/features/maintenance/MaintenancePage';
import { NotificationsPage } from '@/features/notifications/NotificationsPage';
import { NotificationRulesPage } from '@/features/notifications/NotificationRulesPage';
import { ProfilePage } from '@/features/profile/ProfilePage';
import { UsersPage } from '@/features/users/UsersPage';
import { SettingsPage } from '@/features/settings/SettingsPage';
import { AddDevicePage } from '@/features/settings/AddDevicePage';
import { ClientsPage } from '@/features/settings/ClientsPage';
import { LinksPage } from '@/features/settings/LinksPage';
import { NotFoundPage } from '@/features/NotFoundPage';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route index element={<Navigate to="/devices" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/map" element={<MapPage />} />
          <Route path="/devices" element={<DevicesPage />} />
          <Route path="/devices/:id" element={<DeviceDetailPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/reports/events" element={<EventsReportPage />} />
          <Route path="/reports/summary" element={<SummaryReportPage />} />
          <Route path="/reports/trips" element={<TripsReportPage />} />
          <Route path="/reports/stops" element={<StopsReportPage />} />
          <Route path="/reports/route" element={<RouteReportPage />} />
          <Route path="/reports/hours" element={<HoursReportPage />} />
          <Route path="/geofences" element={<GeofencesPage />} />
          <Route path="/maintenance" element={<MaintenancePage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/notifications/rules" element={<NotificationRulesPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/settings/devices/new" element={<AddDevicePage />} />
          <Route path="/settings/devices/edit/:id" element={<AddDevicePage />} />
          <Route path="/settings/clients" element={<ClientsPage />} />
          <Route path="/settings/links" element={<LinksPage />} />
        </Route>
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
